import { gql } from '@apollo/client';

export const NOTIFICATIONS_QUERY = gql`
  query Notifications(
    $after_id: ID
    $branch_id: ID
    $audience: NotificationAudienceGql
    $limit: Int
  ) {
    notifications(
      after_id: $after_id
      branch_id: $branch_id
      audience: $audience
      limit: $limit
    ) {
      items {
        id
        kind
        branch_id
        audience
        title_key
        body_key
        body_args_json
        reference_kind
        reference_id
        amount_cents
        created_at
      }
      latest_id
    }
  }
`;
